<p>player-schedule works!</p>
